import DialogComponent from "components/Dialog";

import './index.less';

export default class InviteDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            itemsForPeriod: [],
            doctorId: null,
            nextDate: null,
            reasonId: 0,
            info: {},
            visitRulePeriodName: false,
            id: false,
            comment: "",
        };

        this.state = { ...this.defaultState };
    }

    show(title, period, info, reasonId, infoVis, hidCb, clinicId) {
        this.dialogTitle = title || "client.invitationReturnVisit";
        this.relative = true;
        this.state.itemsForPeriod = period;
        this.state.info = info;
        this.state.clinicId = clinicId;
        this.hidCb = hidCb;
        this.state.reasonId = reasonId;

        if (infoVis) {
            this.state.doctorId = infoVis.doctorId;
            this.state.nextDate = infoVis.targetDate;
            this.state.visitRulePeriodName = infoVis.visitRule.visitRulePeriodName;
            this.state.id = infoVis.id;

            const comment = infoVis.visitRule.comment;
            this.setState({ comment });
        }

        super.show();
    }

    save() {
        const { doctorId, info, reasonId, nextDate, id, comment, visitRulePeriodName } = this.state;
        const { id: clientId } = info;
        const { clinicId } = this.state;

        if (nextDate && doctorId) {

            const infoAdd = {
                domainId: clinicId,
                targetDate: this._helper.date.toStr(nextDate),
                clientId: clientId,
                title: this.dialogTitle,
                comment: "",
                remindBefore: null,
                reasonId: reasonId,
                doctorId: doctorId,
                visitRule: {
                    visitRulePeriodName,
                    comment: comment
                }
            };

            if (id)
                infoAdd.id = id;

            this.hide();
            this.hidCb(infoAdd);
        }
    }

    onDateChange(date) {
        this.changeState("nextDate", date);
    }

    onPeriodChange(periodId) {
        const { invitePeriod } = this._config;
        const date = new Date();
        const period = invitePeriod.find(it => it.id === periodId);

        let value = null;

        if (period.add.type === "day")
            value = this._helper.date.addDays(date, period.add.amount);
        else
            value = this._helper.date.addMonth(date, period.add.amount);

        this.selectDateCalendar.value = value;
        this.state.visitRulePeriodName = period.baseName;
        this.changeState("nextDate", value);
    }

    renderContent() {
        const { itemsForPeriod, doctorId, visitRulePeriodName, nextDate, comment } = this.state;

        const item = itemsForPeriod.find(it => it.baseName === visitRulePeriodName);
        const valuePeriodId = visitRulePeriodName ? (item?.id || itemsForPeriod[0].id) : null;
        const items = itemsForPeriod.filter(it => (it.id !== 1 && it.id !== 2 && it.id !== 3));

        return (
            <div className="inviteDialog content flex col gap16 pos rel">
                {this.insertSelectDoctor({
                    label: "client.seeDoctor",
                    value: doctorId,
                    onClick: this.changeState.bind(this, "doctorId")
                })}
                <div className="flex between gap8">
                    <div className="areaInput flex flex1 col gap8">
                        {this.insertSelect({
                            value: valuePeriodId,
                            showLeftIcon: false,
                            label: "client.period",
                            placeHolder: "main.notIndicated",
                            translate: true,
                            items: items,
                            onChange: this.onPeriodChange.bind(this)
                        })}
                    </div>
                    <div className="flex1">
                        {this.insertSelectDate({
                            ref: el => this.selectDateCalendar = el,
                            onChange: this.onDateChange.bind(this),
                            defaultValue: nextDate,
                        })}
                    </div>
                </div>
                <div>
                    {this.insertInput({
                        label: "client.note",
                        placeHolder: "client.note",
                        onChange: this.changeState.bind(this, "comment"),
                        value: comment
                    })}
                </div>
            </div>
        );
    }
}
